/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Scroll from '@/components/Base/Scroll';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import { getV2ObjectCustomerProductionAppList, getCustomerProductionService } from '@/api';
import ExtFieldPc from '@/components/ExtFieldPc.vue';
export default {
  name: 'ProductInfoOrder',
  props: {
    orderId: [String, Number]
  },
  components: {
    ExtFieldPc: ExtFieldPc,
    Scroll: Scroll,
    ViewBox: ViewBox,
    Cell: Cell,
    Group: Group
  },
  data: function data() {
    return {
      isShowModalAddCustomerProduct: false,
      showContentNumber: 0,
      orderReport: [],
      isShowModalAddEquirement: false,
      row: {},
      showList: [],
      pageIndex: 0,
      pageSize: 10,
      codeMap: {}
    };
  },
  computed: {
    sysList: function sysList() {
      var _this = this;
      var list = [{
        name: i18n.tc("197"),
        key: 'productionSn',
        auth: 'customerProduct_num',
        code: 420012
      }, {
        name: i18n.tc("198"),
        key: 'customerName',
        auth: 'customerProduct_customer',
        code: 420013
      },
      // {
      //   name: '产品二维码',
      //   key: 'qr_code',
      //   auth: 'customerProduct_qrCode',
      //   code: 420015
      // },
      {
        name: i18n.tc("200"),
        key: 'warranty_start_date',
        auth: 'p_warranty_start_date_view',
        code: 420001
      }, {
        name: i18n.tc("201"),
        key: 'warranty_end_date',
        auth: 'p_warranty_end_date_view',
        code: 420001
      }, {
        name: i18n.tc("202"),
        key: 'purchasing_date',
        auth: 'p_purchasing_date_view',
        code: 420006
      }, {
        name: i18n.tc("203"),
        key: 'delivery_date',
        auth: 'p_delivery_date_view',
        code: 420004
      }, {
        name: i18n.tc("204"),
        key: 'install_date',
        auth: 'p_install_date_view',
        code: 420005
      }, {
        name: i18n.tc("205"),
        key: 'production_date',
        auth: 'p_production_date_view',
        code: 420003
      }];
      return list.filter(function (v) {
        return _this.codeMap[v.code];
      });
    }
  },
  created: function created() {
    var _this2 = this;
    getCustomerProductionService().then(function (res) {
      if (res.success) {
        res.data.forEach(function (val) {
          _this2.$set(_this2.codeMap, val.code, val.value);
        });
      }
    });
    this.init();
  },
  methods: {
    // 下拉刷新
    onPulldownLoading: function onPulldownLoading() {
      this.init(true);
    },
    // 上拉加载
    onPullupLoading: function onPullupLoading() {
      this.pageIndex = this.pageIndex + 1;
      this.init();
    },
    handleRoute: function handleRoute(item) {
      if (item.customerProId) {
        this.$router.push({
          name: 'ProductFileDetail',
          query: {
            customerProductionId: item.customerProId,
            customerId: item.customerId,
            productId: item.productionId
          }
        });
      }
    },
    init: function init() {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reset;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reset = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                _context.prev = 1;
                if (reset) {
                  _this3.pageIndex = 0;
                }
                _context.next = 5;
                return getV2ObjectCustomerProductionAppList({
                  pageIndex: _this3.pageIndex,
                  pageSize: _this3.pageSize,
                  objectId: _this3.orderId,
                  objectType: 1
                }).then(function (res) {
                  if (res.success) {
                    if (reset) {
                      _this3.orderReport = res.data.list;
                    } else {
                      _this3.orderReport = _this3.orderReport.concat(res.data.list);
                    }
                    if (res.data.list >= _this3.pageSize) {
                      _this3.$refs['orderList'] && _this3.$refs['orderList'].forceUpdate(false);
                    } else {
                      _this3.$refs['orderList'] && _this3.$refs['orderList'].forceUpdate(true);
                    }
                  }
                });
              case 5:
                _context.next = 10;
                break;
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                console.log('AutoConsole: init -> error', _context.t0);
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 7]]);
      }))();
    }
  }
};